/* eslint-disable */
import { Box, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Button, Col, Flex, Form, Input, Row, Select, Spin } from 'antd';
import AntdValuePreview from 'components/dev/AntdValuePreview';
import DetailPageHeader from 'components/header/DetailPageHeader';
import InputLabel from 'components/InputLabel/index';
import MainCard from 'components/MainCard';
import { toastConfig } from 'config';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { filterChildOptionLabel } from 'pages/globals/global';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useGetLynFormDataMutation } from 'store/features/comptroller/comptrollerApi';
import { useGetLynFormPropertyMutation, useGetSingleIdentityMutation } from 'store/features/process/processApi';

function Create() {
	const theme = useTheme();
	const [form] = Form.useForm();

	const { state } = useLocation();
	const navigate = useNavigate();

	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState();

	const [GetSingleIdentity, { error: errorData, isSuccess: isSingleCaseSuccess, isLoading: isSingleCaseLoading, isError: isSingleCaseError }] =
		useGetSingleIdentityMutation();

	const onSubmitHandler = (payload) => {
		// console.log('payload', payload);
		setSubmitData(payload);
		setShowModal(true);
	};

	const onModalOkHandler = () => {
		GetSingleIdentity({
			operation: 'add-single',
			processCode: state?.processCode,
			suffixCode: '',
			data: submitData,
		});
	};

	useEffect(() => {
		if (isSingleCaseSuccess) {
			toast.success('Success! Action completed ', toastConfig);
			navigate(-1);
		}

		if (isSingleCaseError) {
			if (errorData?.data?.code === '501') {
				toast.error(errorData?.data?.message, toastConfig);
			} else {
				toast.error('Failed! Action not completed', toastConfig);
			}
		}
	}, [isSingleCaseSuccess, isSingleCaseError, errorData]);

	// useEffect(() => {
	// 	if (isEmpty(state?.processCode)) {
	// 		navigate(-1);
	// 	}
	// }, [state?.processCode]);

	return (
		<Box>
			<DetailPageHeader title="Create Petty Cash Float" />

			<Spin spinning={isSingleCaseLoading} style={{ maxHeight: '100%' }}>
				<MainCard>
					<Form form={form} layout="vertical" onFinish={onSubmitHandler} autoComplete="off" requiredMark={false}>
						<AntdValuePreview form={form} show={false} />

						<Row gutter={[16, 0]}>
							<Col md={24} lg={6}>
								<InputLabel label="Float ID" head={true} />
							</Col>
							<Col md={24} lg={18}>
								<Form.Item
									name="floatId"
									// rules={[
									// 	{
									// 		required: true,
									// 		message: 'Field is required',
									// 	},
									// ]}
								>
									<Input placeholder="Auto Generated" disabled />
								</Form.Item>
							</Col>
							<Col md={24} lg={6}>
								<InputLabel label="Location" head={true} />
							</Col>
							<Col md={24} lg={18}>
								<NonDependantSelect name="PROPERTY_location" code="PROPERTY_location" displayNameCode="PROPERTY_location_label" />
							</Col>
							<Col md={24} lg={6}>
								<InputLabel label="Assigned Petty Cashier" head={true} />
							</Col>
							<Col md={24} lg={18}>
								<NonDependantSelect
									name="DATA_queryPcoUserIds"
									code="DATA_queryPcoUserIds"
									displayNameCode="DATA_queryPcoUserIds_label"
								/>
							</Col>

							<Col md={24} lg={6}>
								<InputLabel label="Purpose" head={true} />
							</Col>
							<Col md={24} lg={18}>
								<Form.Item
									name="controlId"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<Input.TextArea placeholder="Write here" />
								</Form.Item>
							</Col>

							<Col xs={24}>
								<Flex justify="end">
									<Button type="primary" htmlType="submit" style={{ backgroundColor: theme.palette.lynTheme.main }}>
										Submit
									</Button>
								</Flex>
							</Col>
						</Row>
					</Form>
				</MainCard>
			</Spin>

			{showModal && (
				<ComptrollerConfirmModal
					showModal={showModal}
					modalData={{
						head: state?.processName ?? '',
						label: 'Do you want to proceed?',
					}}
					setShowModal={setShowModal}
					handleSubmit={onModalOkHandler}
				/>
			)}
		</Box>
	);
}

export default Create;

// export const DependantSelect = ({ name, displayNameCode, code, rules, isDependent = false, processCode }) => {
// 	const form = Form.useFormInstance();
// 	const userId = useSelector((state) => state.profile.profileData.userId);
// 	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
// 	const { state } = useLocation();

// 	const [options, setOptions] = useState(isDependent ? [] : null);

// 	const [GetLynFormData, { data: lynFormData }] = useGetLynFormDataMutation();
// 	const [GetLynFormProperty, { data: lynProperty }] = useGetLynFormPropertyMutation();

// 	const onSelectHandler = (value) => {
// 		if (displayNameCode) {
// 			const label = form.getFieldValue(value);
// 			form.setFieldValue(displayNameCode, label);
// 		}
// 	};

// 	useEffect(() => {
// 		if (code?.startsWith('PROPERTY_')) {
// 			GetLynFormProperty({
// 				type: 'FORM',
// 				fieldCode: state?.processCode || processCode,
// 				propertyCode: code,
// 				companyCode,
// 				processVersion: state?.processVersion,
// 				status: 'Active',
// 			});
// 		} else if (code?.startsWith('DATA_')) {
// 			const queryName = code.replace('DATA_', '');
// 			GetLynFormData({
// 				name: queryName,
// 				userId,
// 			});
// 		}
// 	}, [code, userId]);

// 	useEffect(() => {
// 		if (lynProperty?.lynProperties?.length > 0) {
// 			setOptions(lynProperty?.lynProperties);
// 			lynProperty?.lynProperties?.forEach((value) => {
// 				form.setFieldsValue({
// 					[value?.propertyValue]: value?.displayName,
// 				});
// 			});
// 		}

// 		if (lynFormData?.results?.length > 0) {
// 			setOptions(lynFormData?.results);
// 			lynFormData?.results?.forEach((value) => {
// 				form.setFieldsValue({
// 					[value?.propertyValue]: value?.displayName,
// 				});
// 			});
// 		}
// 	}, [lynProperty, lynFormData]);

// 	return (
// 		<>
// 			<Form.Item name={name} rules={rules}>
// 				{options === null ? (
// 					<Skeleton variant="text" sx={{ fontSize: '1rem', marginX: 1 }} />
// 				) : (
// 					<Select
// 						allowClear
// 						style={{ width: '100%' }}
// 						showSearch
// 						filterOption={filterChildOptionLabel}
// 						onSelect={onSelectHandler}
// 						placeholder="Select from the list"
// 						autoComplete="off"
// 					>
// 						{options?.map((value, index) => (
// 							<Select.Option key={index} value={value?.propertyValue}>
// 								{value?.displayName}
// 							</Select.Option>
// 						))}
// 					</Select>
// 				)}
// 			</Form.Item>
// 			<Form.Item noStyle name={displayNameCode} />
// 		</>
// 	);
// };

export const NonDependantSelect = ({ label, name, code, displayNameCode, processCode, onChange = () => {} }) => {
	const form = Form.useFormInstance();
	const userId = useSelector((state) => state.profile.profileData.userId);
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
	const { state } = useLocation();

	const [options, setOptions] = useState(null);

	const [GetLynFormData, { data: lynFormData }] = useGetLynFormDataMutation();
	const [GetLynFormProperty, { data: lynProperty }] = useGetLynFormPropertyMutation();

	const onSelectHandler = (value, obj) => {
		if (obj?.children) {
			form.setFieldValue(displayNameCode, obj?.children);
		}

		onChange();
	};

	useEffect(() => {
		if (code?.startsWith('PROPERTY_')) {
			GetLynFormProperty({
				type: 'FORM',
				fieldCode: state?.processCode || processCode,
				propertyCode: code,
				companyCode,
				processVersion: state?.processVersion,
				status: 'Active',
			});
		} else if (code?.startsWith('DATA_')) {
			const queryName = code.replace('DATA_', '');
			GetLynFormData({
				name: queryName,
				userId,
			});
		}
	}, [code, userId]);

	// Store options code & displayName in form.
	useEffect(() => {
		if (lynProperty?.lynProperties?.length > 0) {
			setOptions(lynProperty?.lynProperties);
			lynProperty?.lynProperties?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}

		if (lynFormData?.results?.length > 0) {
			setOptions(lynFormData?.results);
			lynFormData?.results?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}
	}, [lynProperty, lynFormData]);

	return (
		<>
			<Form.Item
				label={label}
				name={name}
				rules={[
					{
						required: true,
						message: 'Field is required',
					},
				]}
			>
				<Select
					allowClear
					showSearch
					style={{ width: '100%' }}
					onSelect={onSelectHandler}
					filterOption={filterChildOptionLabel}
					placeholder="Select from the list"
				>
					{options === null ? (
						<Skeleton variant="text" sx={{ fontSize: '1rem', marginX: 1 }} />
					) : (
						options?.map((value, index) => (
							<Select.Option key={index} value={value?.propertyValue}>
								{value?.displayName}
							</Select.Option>
						))
					)}
				</Select>
			</Form.Item>
			<Form.Item noStyle name={displayNameCode} />
		</>
	);
};
